// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as OrderStage from "../entities/OrderStage.bs.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as TicketRaisedBy from "../entities/TicketRaisedBy.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";

function execute(ticket) {
  return Json_encode.object_({
              hd: [
                "caller_number",
                ticket.callerNumber
              ],
              tl: {
                hd: [
                  "msisdn",
                  ticket.msisdn
                ],
                tl: {
                  hd: [
                    "crn",
                    ticket.crn
                  ],
                  tl: {
                    hd: [
                      "location",
                      ticket.location
                    ],
                    tl: {
                      hd: [
                        "order_stage",
                        OrderStage.toString(ticket.orderStage)
                      ],
                      tl: {
                        hd: [
                          "raised_by",
                          TicketRaisedBy.toString(ticket.raisedBy)
                        ],
                        tl: {
                          hd: [
                            "issue",
                            $$Array.of_list(ticket.issues)
                          ],
                          tl: {
                            hd: [
                              "ticket_action",
                              $$Array.of_list(ticket.actions)
                            ],
                            tl: {
                              hd: [
                                "issue_comments",
                                ticket.issueComments
                              ],
                              tl: {
                                hd: [
                                  "action_comments",
                                  ticket.actionComments
                                ],
                                tl: {
                                  hd: [
                                    "start_ts",
                                    DateTime$Catalyst.toString(undefined, ticket.startTs)
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

export {
  execute ,
  
}
/* DateTime-Catalyst Not a pure module */
